import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import { DataLogin } from '@/types'

@Component
export default class FormLoginComponent extends Vue {
  // #region data
  data: DataLogin = {
    password: '',
    username: '',
    ruc: ''
  }
  // #endregion
  // #region methods
  @Emit('login')
  onLogin (data: DataLogin): DataLogin {
    return {
      username: data.username,
      password: data.password,
      ruc: (document.head.querySelector('meta[name="ruc"]') as any).content
    }
  }
  // #endregion
}
